const contactBoxIcon = document.querySelectorAll('.ask-to-contact__icon');
const quickContact = document.getElementById('quickContact');
const quickContactBtn = document.getElementById('quickContactBtn');

if (!!contactBoxIcon.length) {
    contactBoxIcon.forEach(item => {
        item.addEventListener('click', () => {
            item.parentElement.classList.toggle('is-hidden');
        });
    });
}

if (quickContact) {
    document.addEventListener('DOMContentLoaded', () => {
        const quickContactCloseBtn = quickContact.querySelector('.quick-contact__close');

        window.addEventListener('scroll', () => {
            if (document.documentElement.scrollTop > 300) {
                quickContact.classList.add('is-hidden');
                quickContactBtn.classList.remove('is-hidden');
            } else {
                quickContact.classList.remove('is-hidden');
                quickContactBtn.classList.add('is-hidden');
            }
        });
    
        quickContactBtn.firstElementChild.addEventListener('click', () => {
            window.scrollTo(0, 0);
            quickContact.removeAttribute('style');
            quickContactBtn.removeAttribute('style');
        });

        quickContactCloseBtn.addEventListener('click', () => {
            quickContact.style.display = 'none';
            quickContactBtn.style.display = 'block';
        });
    });


}